module.exports = __webpack_public_path__ + "04_glasses_black.efaccd56.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/04_glasses_black.png
// module id = NUm6
// module chunks = 0